import styled from 'styled-components/macro';

export const StyledTabularDataRow = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 0;

  &:nth-child(odd) {
    background-color: ${p => p.theme.gray100};
  }

  border-bottom-width: 1px;
  border-color: ${p => p.theme.gray200};
`;

export const StyledTabularTitle = styled.div`
  width: 33.333333%;
  padding-left: 0.5rem;
`;

export const StyledTabularValue = styled.div`
  font-weight: 600;
  width: 66.666667%;
  font-size: 1rem;
`;

export const StyledTabularContainer = styled.div`
  margin: 0 1.25rem;
`;
